import { Pipe, PipeTransform } from '@angular/core';
import { SignRequestStatus, SignRequestStatusName } from '@dpr/enums';
import {
  DprReportSignRequestStatus,
  Signer,
} from '@dpr/models/digital-signature';

@Pipe({ name: 'eSignStatusText' })
export class ESignStatusTextPipe implements PipeTransform {
  transform(data: Signer | DprReportSignRequestStatus): string {
    return SignRequestStatusName.has(data?.status)
      ? SignRequestStatusName.get(data?.status)
      : SignRequestStatusName.get(SignRequestStatus.Default);
  }
}
